import React from "react";
import "./Login.sass"
import LoginForm from "./LoginForm";
import on from '../../img/profileImg/registr.png'
import {connect} from "react-redux";
import {loginMe, setActivePageSite} from "../../Redux/authReducer";
import facebook from "../../img/profileImg/facebook.png"
import twitter from "../../img/profileImg/twitter.png"
import smile2 from "../../img/smile2.png"
import {Redirect} from "react-router-dom";
class Login extends React.Component {

    componentDidMount() {
        this.props.setActivePageSite("LOGIN")
    }
    state = {
        login: true
    };

    onSubmit = (loginForm) => {
        this.props.loginMe(loginForm)
    };

    render() {
        if (this.props.isAuth)
            return <Redirect to={"/profile"}/>;
        return (
            <section className='login'>
                <div className='login__bg-header'>
                    <div className="login__container container">
                        <div className='login__info'>
                                <h1>Welcome to the Biggest Social Network in the World</h1>
                                <h2>We are the best and biggest social network with 5 billion active users all around the
                                    world. Share you thoughts, write blog posts, show your favourite music via Stopify,
                                    earn badges and much more!
                                </h2>
                            <a href="https://social-network.samuraijs.com/signUp" rel="noopener noreferrer" target="_blank">Зарегистрируйся сейчас</a>
                        </div>
                        <div className={this.props.captcha ? "login__input-window login__input-window-with-captcha" : "login__input-window"}>
                            <div className='login__switch-panel'>
                                <button onClick={() => this.setState({login: true})}><img src={on} alt=""/></button>
                                <button onClick={() => this.setState({login: false})}><img src={on} alt=""/></button>
                            </div>
                            {this.state.login &&
                                <div className="login__input-fields">
                                    <LoginForm onSubmit={this.onSubmit} captcha={this.props.captcha}/>
                                    <div className="login__additional-network">
                                        <p className='or additional-text'>OR</p>
                                        <div className="submit-button"><button><img src={facebook} alt=""/>Login with Facebook</button></div>
                                        <div className="submit-button"><button><img src={twitter} alt=""/>Login with Twitter</button></div>
                                    </div>
                                </div>
                            }
                            {!this.state.login &&
                            <div className="login__registration login__input-fields">
                                <div className="login__window-title"><h3>Регистрация!</h3></div>
                                <div className="login__input-field">
                                    <p className='main-text'>К сожалению регистрация пока отсуствует на этом сайте, для того чтобы зарегистрироваться нужно перейти на <a href="https://social-network.samuraijs.com/signUp" rel="noopener noreferrer" target="_blank">сайт нашей базы данных</a>, там зарегистрироваться и перейти обратно</p>
                                    <p className='main-text'>Это единственный способ зарегистрироваться</p>
                                    <p className='main-text'>Спасибо за понимание</p>
                                    <img src={smile2} alt=""/>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

let mapStateToProps = (state) => {
    return {
        isAuth: state.auth.isAuth,
        captcha: state.auth.captcha
    }
};

export default connect(mapStateToProps, {setActivePageSite, loginMe})(Login);